<template>

  <a target="_blank" :href="item.pdf">
    <pdf ref="pdf" :src="item.pdf" :resize="true" :text="false">
      <template slot="loading">

      </template>
    </pdf>
  </a>

</template>

<script>
  import pdf from 'pdfvuer'

  export default {
    name: 'Training',
    components: {
      pdf
    },
    data() {
      return {
        item: {
          pdf: "https://www.asspm.fr/rubriques//horaires_entrainements.pdf"
        }
      }
    }
  }

</script>